import React from 'react';

import { injectIntl } from 'react-intl';

import * as styles from './empty-state.styled';

export type PromoComponentProps = {
  promoItems: PromoItem[];
};

export type PromoItem = {
  icon: JSX.Element;
  title: string;
  description: string;
  url: string;
  videoUrl?: string;
};

export type PromoComponentState = {
  selectedIndex: number;
};

export type PromoButtonProps = {
  icon: any;
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
};

const PromoMenuButton = (props: PromoButtonProps) => {
  const { icon, title, description, selected, onClick } = props;

  return (
    <styles.PromoButton selected={selected} onClick={onClick}>
      {icon}
      <styles.PromoButtonTitle>{title}</styles.PromoButtonTitle>
      <styles.PromoButtonDescription>
        {description}
      </styles.PromoButtonDescription>
    </styles.PromoButton>
  );
};

class PromoComponent extends React.Component<
  PromoComponentProps,
  PromoComponentState
> {
  // @ts-ignore TODO: fix noImplicitAny error here
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
    };
  }

  // @ts-ignore TODO: fix noImplicitAny error here
  handleClick(index) {
    this.setState({ selectedIndex: index });
  }

  render() {
    const promoImage = (
      <img
        src={this.props.promoItems[this.state.selectedIndex].url}
        alt={this.props.promoItems[this.state.selectedIndex].title}
        width="100%"
      />
    );
    let promoMedia;

    if (this.props.promoItems[this.state.selectedIndex].videoUrl) {
      promoMedia = (
        <video
          key={this.props.promoItems[this.state.selectedIndex].title}
          width="100%"
          autoPlay
          loop
          muted
        >
          <source
            src={this.props.promoItems[this.state.selectedIndex].videoUrl}
            type="video/mp4"
          />
          {promoImage}
        </video>
      );
    } else {
      promoMedia = promoImage;
    }

    return (
      <styles.Promo>
        <styles.PromoImage>{promoMedia}</styles.PromoImage>
        <styles.PromoMenu>
          {this.props.promoItems.map((promoItem, index) => {
            return (
              <PromoMenuButton
                key={promoItem.title}
                icon={promoItem.icon}
                title={promoItem.title}
                description={promoItem.description}
                selected={index === this.state.selectedIndex}
                onClick={() => this.handleClick(index)}
              />
            );
          })}
        </styles.PromoMenu>
      </styles.Promo>
    );
  }
}

export default injectIntl(PromoComponent);
